import { forwardRef, useEffect, useRef, useState } from "react";

// Blur-editors follow remote changes without submitting an untouched, stale value.
export const SyncedInput = forwardRef(function SyncedInput(inputProps, ref) {
  const { as: Tag = "input", defaultValue, onBlur, onFocus, onChange, ...props } = inputProps;
  const [draft, setDraft] = useState(defaultValue ?? "");
  const focused = useRef(false);
  const original = useRef(defaultValue);
  useEffect(() => {
    if (!focused.current) setDraft(defaultValue ?? "");
  }, [defaultValue]);
  if (!("defaultValue" in inputProps)) return <Tag ref={ref} {...props} onBlur={onBlur} onFocus={onFocus} onChange={onChange} />;
  return <Tag ref={ref} {...props} data-protected-input="true" value={draft}
    onFocus={(e) => { focused.current = true; original.current = draft; onFocus?.(e); }}
    onChange={(e) => { setDraft(e.target.value); onChange?.(e); }}
    onBlur={(e) => {
      focused.current = false;
      if (String(e.target.value) !== String(original.current ?? "")) onBlur?.(e);
      else setDraft(defaultValue ?? "");
    }} />;
});
